var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 11.6875V30.3125H21V33H10.3125C9.60417 33 8.97917 32.7292 8.4375 32.1875C7.9375 31.6458 7.6875 31.0208 7.6875 30.3125V11.6875C7.6875 10.9792 7.9375 10.3542 8.4375 9.8125C8.97917 9.27083 9.60417 9 10.3125 9H21V11.6875H10.3125ZM27.6875 14.3125L34.3125 21L27.6875 27.6875L25.8125 25.75L29.25 22.3125H15.6875V19.6875H29.25L25.8125 16.1875L27.6875 14.3125Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.f3221d1c6bfb632dca881f80f946d202.svg";
export { ForwardRef as ReactComponent };